export const SearchItemContainer = ({ children }: any) => (
  <div className="bg-primary">{children}</div>
);
